<div id="theme-demo">
  <select id="selector" class="form-control" [ngModel]="selectedValue" (change)="update($event.target.value)">
    <option value="">Seleccione un theme</option>
    <option *ngFor="let option of getOptions()" value="{{ option.Key }}">
      {{option.Key}}
    </option>
  </select>
</div>